<template>
  <div id="newDetail">
    <div class="box">
      <div class="tit">
        <span>
          <router-link :to="{path: '/index'}">
            首页
          </router-link>
        </span>>
        <span>
          <router-link :to="{name: '案例中心'}">
            案例中心
          </router-link>
        </span>>
        <span>
          案例详情
        </span>
      </div>
    </div>
    <div class="content">
      <div>
        <div class="title">{{title}}</div>
        <div class="tbox">
          <div>{{type_name}}</div>
          <div class="time">{{resetT(public_date)}}</div>
        </div>
        <div class="ql-editor">
          <div v-html="detail" class="news-content"></div>
        </div>
      </div>
      <div>
        <Thehot :list="hotlist"></Thehot>
      </div>
    </div>
  </div>
</template>

<script>
import Thehot from '../../casemget/camgtype/hotlist';
import { getcase } from '@/api/portal';
import { resetT } from '../../../common/date-format';
export default {
  data() {
    return {
      hotlist: [],
      title: '', //资讯标题
      type_name: '', //资讯类型
      public_date: '', //发布日期
      detail: '', //资讯正文
      titlename: '',
    };
  },
  components: {
    Thehot,
  },
  methods: {
    resetT,
    //获取经典案例
    _gethotlist() {
      getcase({
        is_hot: 2,
        page_index: 1,
        page_size: 3,
      })
        .then(res => {
          this.hotlist = res.data;
        })
        .catch(err => {});
    },
    //获取资讯详情
    _getnewsInfo() {
      getcase({
        id: this.$route.query.id,
      })
        .then(res => {
          if (res.state == 1) {
            if (res.state == 1) {
              var data = res.data;
              for (var i = 0; i < data.length; i++) {
                if (data[i].id == this.$route.query.id) {
                  var row = data[i];
                  this.title = row.title;
                  this.public_date = row.publish_date;
                  this.type_name = row.type_name;
                  this.detail = row.detail.replace(/nesw\-resize/g, 'auto');
                }
              }
            }
          }
        })
        .catch(err => {});
    },
  },
  created() {
    this._getnewsInfo();
    this._gethotlist();
    this.titlename = this.$route.query.title;
    document.title = this.titlename;
  },
};
</script>

<style lang="scss">
@import './quill.core.scss';
@import './quill.snow.scss';
@import './quill.bubble.scss';
@import './quill-edit.config.scss';
#newDetail {
  .box {
    background-color: rgba(0, 0, 0, 0.05);
  }
  .content {
    width: 1180px;
    margin: 0 auto;
    padding: 60px 0;
  }
  .tit {
    height: 64px;
    line-height: 64px;
    width: 1176px;
    margin: 0 auto;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.48);
  }
  .tit span:not(:last-child) {
    margin-right: 8px;
  }
  .tit span:nth-child(2),
  .tit span:nth-child(3) {
    margin-left: 8px;
  }
  .tit a {
    color: rgba(0, 0, 0, 0.48);
  }
  .tit a:hover {
    text-decoration: none;
  }
  .tit span:nth-child(3) {
    color: rgba(0, 0, 0, 0.88);
  }
  .content > div,
  .tbox > div {
    display: inline-block;
    vertical-align: top;
  }
  .content > div:first-child {
    width: 778px;
  }
  .content > div:last-child {
    width: 276px;
    margin-left: 104px;
  }
  .title {
    color: rgba(0, 0, 0, 0.88);
    font-size: 24px;
  }
  .tbox {
    font-size: 0;
    margin: 15px 0 25px;
  }
  .tbox > div {
    color: rgba(0, 0, 0, 0.48);
    font-size: 12px;
  }
  .tbox > div:last-child {
    margin-left: 12px;
    position: relative;
  }
  .tbox > div:last-child::before {
    content: '';
    position: absolute;
    width: 2px;
    height: 10px;
    background-color: rgba(0, 0, 0, 0.38);
    left: -7px;
    top: 5px;
  }
  .news-content {
    font-size: 16px;
  }
}
</style>
